import { Component, OnDestroy, OnInit, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-banner-carousel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './banner-carousel.component.html',
  styleUrl: './banner-carousel.component.css'
})
export class BannerCarouselComponent implements OnInit, OnDestroy {
  readonly bannerImages = signal<string[]>([
    '/img/banners/banner-1.jpg',
    '/img/banners/banner-2.jpg',
    '/img/banners/banner-3.jpg',
  ]);

  readonly currentIndex = signal(0);
  readonly nextIndex = computed(() => {
    const len = this.bannerImages().length;
    if (len === 0) return 0;
    return (this.currentIndex() + 1) % len;
  });

  private intervalId?: number;
  private readonly intervalMs = 5000;

  ngOnInit(): void {
    this.startAutoPlay();
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
  }

  goToSlide(index: number): void {
    this.currentIndex.set(this.normalizeIndex(index));
    this.restartAutoPlay();
  }

  next(): void {
    this.currentIndex.set(this.normalizeIndex(this.currentIndex() + 1));
    this.restartAutoPlay();
  }

  prev(): void {
    this.currentIndex.set(this.normalizeIndex(this.currentIndex() - 1));
    this.restartAutoPlay();
  }

  private startAutoPlay(): void {
    this.stopAutoPlay();
    this.intervalId = globalThis.setInterval(() => {
      this.currentIndex.set(this.normalizeIndex(this.currentIndex() + 1));
    }, this.intervalMs);
  }

  private stopAutoPlay(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }

  private restartAutoPlay(): void {
    this.startAutoPlay();
  }

  private normalizeIndex(index: number): number {
    const len = this.bannerImages().length;
    if (len === 0) return 0;
    return ((index % len) + len) % len;
  }
}
